module.exports = __webpack_public_path__ + "static/img/092_TO8_1759_og.6e4c90e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/092_TO8_1759_og.jpg
// module id = 9wpU
// module chunks = 0